export default __webpack_public_path__ + "static/media/bangkog.006463ce.svg";